import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { AGENT_SETTINGS } from "@/constants/testIds";

/** Reglas de conversacion: respuestas a objeciones de precio y palabras
 * clave que escalan la conversacion a un humano. */
export default function RulesTab({ config, onSave }) {
  const [form, setForm] = useState(null);
  const [keywordsText, setKeywordsText] = useState("");
  const [casesText, setCasesText] = useState("");  // Fix AU (2026-10-27)
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (config) {
      setForm({
        price_objection_response_es: config.price_objection_response_es || "",
        price_objection_response_en: config.price_objection_response_en || "",
      });
      setKeywordsText((config.escalation_keywords || []).join(", "));
      setCasesText(config.escalation_cases || "");
    }
  }, [config]);

  if (!form) return <p className="text-sm text-muted-foreground">Cargando...</p>;

  const set = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSave = async () => {
    setSaving(true);
    try {
      await onSave({
        price_objection_response_es: form.price_objection_response_es || null,
        price_objection_response_en: form.price_objection_response_en || null,
        escalation_keywords: keywordsText.split(",").map((k) => k.trim()).filter(Boolean),
        escalation_cases: casesText,
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-6 max-w-2xl">
      <div>
        <Label className="text-sm text-muted-foreground mb-1 block">Respuesta a objecion de precio (Español)</Label>
        <p className="text-xs text-muted-foreground mb-1">Que decir cuando el lead dice que es caro, pide descuento o compara precios.</p>
        <Textarea value={form.price_objection_response_es} onChange={set("price_objection_response_es")} rows={3} data-testid={AGENT_SETTINGS.priceObjectionEsInput} />
      </div>
      <div>
        <Label className="text-sm text-muted-foreground mb-1 block">Respuesta a objecion de precio (English)</Label>
        <Textarea value={form.price_objection_response_en} onChange={set("price_objection_response_en")} rows={3} data-testid={AGENT_SETTINGS.priceObjectionEnInput} />
      </div>
      {/* Fix AU (2026-10-27): "tienen que poner todos los casos en los que la IA ya tenga que derivar a la ejecutiva" (reunión de revisión con el equipo) */}
      <div>
        <Label className="text-sm text-muted-foreground mb-1 block">Casos en los que el agente siempre pasa con una persona del equipo</Label>
        <p className="text-xs text-muted-foreground mb-1">Escribí un caso por renglón, con tus palabras. Cuando una conversación entre en alguno, o cuando el agente dude de si algo se sale de lo que sabe, avisa que la deriva y el chat pasa al equipo.</p>
        <Textarea
          value={casesText}
          onChange={(e) => setCasesText(e.target.value)}
          rows={6}
          placeholder={"Ej.: Quiere comparar fotos de antes y después de un caso suyo\nPregunta por un tratamiento que no está en la lista\nPide una cita para hoy o mañana"}
          data-testid={AGENT_SETTINGS.escalationCasesInput}
        />
        <p className="text-xs text-muted-foreground mt-1" data-testid={AGENT_SETTINGS.escalationCasesCount}>{casesText.split("\n").filter((l) => l.trim()).length} de 30 casos</p>
      </div>
      <div>
        <Label className="text-sm text-muted-foreground mb-1 block">Palabras o frases que escalan a un humano (separadas por coma)</Label>
        <p className="text-xs text-muted-foreground mb-1">Ademas de estas, el agente siempre escala si detecta que el tema es complejo o el lead lo pide explicitamente. Tambien escala con frases como "contactar asesor", "hablar con una asesora" o "una ejecutiva".</p>
        <Textarea value={keywordsText} onChange={(e) => setKeywordsText(e.target.value)} rows={3} data-testid={AGENT_SETTINGS.escalationKeywordsInput} />
      </div>
      <Button onClick={handleSave} disabled={saving} className="bg-brand hover:bg-brand-hover text-white" data-testid={AGENT_SETTINGS.saveRulesButton}>
        {saving ? "Guardando..." : "Guardar reglas"}
      </Button>
    </div>
  );
}
